import { createDynamicSelectComponent } from "../enhanced-factories";
import { TicketTemplate } from "@/lib/types/database";

// Base dynamic select without add-new
const BaseTemplateSelect = createDynamicSelectComponent<TicketTemplate>(
  (templates: TicketTemplate[]) =>
    templates
      .filter((template) => template.id != null && template.id !== "")
      .map((template) => {
        const name = template.name || "Unnamed Template";
        // A template with no description must render its NAME, not
        // "Name - undefined": `description?.slice()` yields `undefined`, which
        // template-literal interpolation stringifies straight into the picker.
        const description = template.description?.trim();
        const summary = description
          ? `${description.slice(0, 50)}${description.length > 50 ? "..." : ""}`
          : "";
        return {
          value: String(template.id),
          label: summary ? `${name} - ${summary}` : name,
          searchableText: `${template.name || ""} ${template.title || ""} ${template.description || ""}`,
        };
      }),
  "Search for template..."
);

// Export a wrapper that enables recents by default with a stable key
export function TemplateSelect(props: any) {
  return <BaseTemplateSelect enableRecents recentKey="ticket_templates" recentMax={8} {...props} />;
}
